/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_SubInputs */

const en_cp_cmp_sub = /** @type {(inputs: Cp_Cmp_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep does not select, fund or run a full-time curriculum. It gives a proof loop lecturers can grade — and documents ready to take to those programs.`)
};

const id_cp_cmp_sub = /** @type {(inputs: Cp_Cmp_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep tidak menyeleksi, tidak mendanai, dan tidak memberi kurikulum full-time. Bystep memberi loop bukti yang bisa dinilai dosen — dan dokumen yang siap dibawa ke program-program itu.`)
};

/**
* | output |
* | --- |
* | "Bystep does not select, fund or run a full-time curriculum. It gives a proof loop lecturers can grade — and documents ready to take to those programs." |
*
* @param {Cp_Cmp_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_sub = /** @type {((inputs?: Cp_Cmp_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_sub(inputs)
	return en_cp_cmp_sub(inputs)
});